import { IListItem } from "./interfaces"

export const Input:React.FC<{ 
    label:string, 
    type?:string, 
    id:string, 
    placeholder?:string|undefined,
    className:string,
    value?:string|number|readonly string[]|undefined
    onChange?: (e:any) => void
}> = ({ label, type="input", id, placeholder, className="col-md-6",value, onChange }) => {
    return (
        <div className={className}>
            <input value={(value ? value : '' )} type="text" id={id} className="form-control" placeholder={placeholder ? placeholder : label} onChange={ onChange }/>
        </div>
    )
} 


export const Select:React.FC<{
    label:string, 
    id:string, 
    placeholder?:string|undefined,
    className:string,
    values:IListItem[]|undefined
    value?:string|number|readonly string[]|undefined
    onChange?: (e:any) => void
}> = ({ label, id, placeholder, className="col-md-6",value, onChange, values }) => {
    return (
        <div className={className}>
            <div className="form-floating">
                <select value={(value ? value : '')} onChange={ onChange } id={id} className="form-control" placeholder={placeholder ? placeholder : label}>
                    <option value="">- Seleccionar -</option>
                    {values ? values?.map((value, key) => {
                        return (
                            <option key={key} value={value.value}>{value.label}</option>
                        )
                    }) : null}
                </select>
                <label htmlFor={id}>{label}</label>
            </div>
        </div>
    )
}